import "./ResponsiveSettings.css";
import useSettings from "./useSettings";
import SystemLocation from "./SystemLocation/SystemLocation.js";
import SystemUserInfo from "./SystemUserInfo/SystemUserInfo.js";
import SystemWork from "./SystemWork/SystemWork.js";
import SystemTerms from "./SystemTerms/SystemTerms.js";

import { NavLink, Route, Routes } from "react-router-dom";
import { getTranslatedText as translate } from "../Localization/Translation";

function Settings() {
  const { locale, mainTabClick, clickHamburger } = useSettings();

  return (
    <div className="main-component">
      <div className="hamburger-third-level-container">
        <div className="hamburger-third-level" onClick={clickHamburger}>
          <span className="bar-third-level"></span>
          <span className="bar-third-level"></span>
          <span className="bar-third-level"></span>
        </div>
      </div>
      <div className="main-navbar main-navbar-settings" dir="auto">
        <NavLink
          to="/Navbar/Settings/Password"
          className="password-settings-tab main-tab current-main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".password-settings-tab")}
        >
          <span>{translate("user-info-settings-tab", locale)}</span>
        </NavLink>
        {/* <NavLink to='/Navbar/Settings/location' className="location-settings-tab main-tab nav-link-main-navbar" onClick={() => mainTabClick('.location-settings-tab')}>
                    <span>{translate('location-settings-tab', locale)}</span>
                </NavLink> */}
        <NavLink
          to="/Navbar/Settings/TermsAndConditions"
          className="Terms-Conditions-settings-tab main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".Terms-Conditions-settings-tab")}
        >
          <span>{translate("Terms-Conditions-settings-tab", locale)}</span>
        </NavLink>
        <NavLink
          to="/Navbar/Settings/SystemWork"
          className="system-work-settings-tab main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".system-work-settings-tab")}
        >
          <span>{translate("system-work-settings-tab", locale)}</span>
        </NavLink>
      </div>

      <Routes>
        <Route path="Password" element={<SystemUserInfo />} />
        <Route path="location" element={<SystemLocation />} />
        <Route path="TermsAndConditions" element={<SystemTerms />} />
        <Route path="SystemWork" element={<SystemWork />} />
      </Routes>
    </div>
  );
}

export default Settings;
